export * from './src/tips-staff-v1-staff-tippable-staff.meta.js';
